import { useContext } from "react";

import { EditSourceFormContext } from "@/pages/sources/components/edit/EditSourceFormProvider";

export function useEditSourceFormContext() {
  const context = useContext(EditSourceFormContext);
  if (!context) {
    throw new Error("useEditSourceFormContext must be used within a EditSourceFormProvider");
  }
  return context;
}
